import { Component, Prop } from '@stencil/core';
import { analyticsLoad } from '../../utils/tracking-utils';

@Component({
	tag: 'dng-analytics-load',
})
export class AnalyticsLoad {
	@Prop() writeKey: string;

	componentWillLoad() {
		analyticsLoad(this.writeKey);
	}
}
